import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { Tabs } from "antd";
import { EXPORT_RUNNING } from '../../../../services/Sierra/sweep';
import { updateExportImportLogPanel } from '../../store/sweep/action';
import { getPanelMaxHeight, getPanelMaxWidth, getPanelWidth } from '../../../../services/helper/panelSizeHelper';
import { getColorClassNameByPrefix } from '../../../../services/helper/monitorLog';

const EXPORT = "Export", IMPORT = "Import";
class ExportImportLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabKey: EXPORT,
      maxWidth: 800,
      maxHeight: 600
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.resize);
    this.resize();
    const { sweepExportStatus, sweepImportStatus, showExportImportLog } = this.props;
    let tabKey = EXPORT;
    if (showExportImportLog && showExportImportLog.key) {
      tabKey = showExportImportLog.key
    } else if ((!sweepExportStatus || !sweepExportStatus.log || !sweepExportStatus.log.length)
      && sweepImportStatus && ((sweepImportStatus.log && sweepImportStatus.log.length) || sweepImportStatus.status === EXPORT_RUNNING)) {
      tabKey = IMPORT;
    }
    this.setState({
      tabKey
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize)
  }

  componentDidUpdate = (prevProps) => {
    const { showExportImportLog } = this.props;
    if ((!prevProps.showExportImportLog && showExportImportLog && showExportImportLog.key) || (showExportImportLog && prevProps.showExportImportLog && showExportImportLog.key !== prevProps.showExportImportLog.key)) {
      this.setState({
        tabKey: showExportImportLog.key
      })
    }
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 800) - 60,
      maxWidth: getPanelMaxWidth(offset, 600)
    })
  }

  onTabChange = (key) => {
    this.setState({
      tabKey: key
    })
  };

  getTabList = () => {
    const { sweepExportStatus, sweepImportStatus, showExportImportLog } = this.props;
    let items = [];
    if ((sweepExportStatus && (sweepExportStatus.status === EXPORT_RUNNING || (sweepExportStatus.log && sweepExportStatus.log.length)))
      || (showExportImportLog && showExportImportLog.key === EXPORT)) {
      items.push({
        key: EXPORT,
        label: EXPORT,
        children: this.getLogDisplay((sweepExportStatus || {}).log)
      })
    }

    if ((sweepImportStatus && (sweepImportStatus.status === EXPORT_RUNNING || (sweepImportStatus.log && sweepImportStatus.log.length)))
      || (showExportImportLog && showExportImportLog.key === IMPORT)) {
      items.push({
        key: IMPORT,
        label: IMPORT,
        children: this.getLogDisplay((sweepImportStatus || {}).log)
      })
    }

    return items;
  }

  getLogDisplay = (log) => {
    if (!log || !log.length) {
      return null;
    }

    return <div className="sweep-export-import-log-content">
      {log.map((logItem, index) => {
        const colorClassName = getColorClassNameByPrefix(logItem);
        return <p key={index}
          className={`sweep-export-import-log-item ${colorClassName}`}
        >
          {logItem}
        </p>
      })}
    </div>

  }

  closeModal = () => {
    const { showExportImportLog } = this.props;
    this.props._updateExportImportLogPanel({ ...showExportImportLog, status: false });
  }

  render() {
    const { tabKey, maxHeight, maxWidth } = this.state;
    const items = this.getTabList();
    const content = (
      <Panel
        className='sierra-sweeping-export-import-panel sierra-panel'
        title={<span>Export / Import Excel Log</span>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, { defaultWidth: 660 })}
        minWidth={200}
        minHeight={200}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        position='panel-center'
        draggable
      >
        <div className="sweep-export-import-content">
          <Tabs activeKey={tabKey} items={items} onChange={this.onTabChange} />
        </div>
      </Panel>
    )
    return createPortal(content, this.dialogRoot);
  }

}

const mapState = (state) => {
  const { SierraReducer: {
    sweep: { sweepExportStatus, sweepImportStatus, showExportImportLog },
  } } = state;
  return {
    sweepExportStatus,
    sweepImportStatus,
    showExportImportLog
  };
}

const mapDispatch = (dispatch) => ({
  _updateExportImportLogPanel(showExportImportLog) {
    dispatch(updateExportImportLogPanel(showExportImportLog))
  }
})

export default connect(mapState, mapDispatch)(ExportImportLog);
